
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 840 420"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#007a3d","d":"M0 0h840v420H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M0 0h840v280H0z"}}),_c('path',{attrs:{"d":"M0 0h840v140H0z"}}),_c('path',{attrs:{"d":"M0 0v420l420-210z","fill":"#ce1126"}}),_c('path',{attrs:{"d":"M129.787 180l6.508 16.485 16.947-5.19-8.83 15.367 14.623 10.014-17.52 2.676 1.289 17.677L129.787 225l-13.016 12.03 1.289-17.678-17.52-2.676 14.623-10.014-8.83-15.367 16.946 5.19L129.787 180z","fill":"#fff"}})])
          )
        }
      }
    